import React from 'react';

/**
 * Page for managing agency recruits.
 */
export const Recruits = () => {
  return (
    <div>
      <h2>Agency Recruits</h2>
    </div>
  );
};
